import React from 'react';
import EntraIdLogo from './Microsoft-Entra-ID-color-icon.svg?react';

export const MicrosoftEntraIdLogo = (props: React.SVGProps<SVGSVGElement>) => {
    return <EntraIdLogo {...props} />;
};
